import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <App base="https://api.kerst.vdweem.xyz"/>
    </BrowserRouter>
);
